import React, { useState, useEffect, useContext, useMemo } from "react";

import { useHeaderTitle } from "../../components/layout/layout";
import './settings.scss';
import { ProfileDetails } from "../../components/settings/profileDetails/ProfileDetails";
import { AccountDetails } from "../../components/settings/accountDetails/AccountDetails";

export default function Settings() {
     const { setHeaderTitle } = useHeaderTitle();
        useEffect(() => {
            setHeaderTitle("Settings");
        }, []);
    return (
      <section className="settings-wrapper">
        <ProfileDetails />
        <AccountDetails />
      </section>
    )
}